import VideoPlayerBase from './video-player-base';

export default class YoutubePlayer extends VideoPlayerBase {
  static getPlayer(iframe) {
    return new YT.Player(iframe.id);
  }

  autoplay() {
    this.player.addEventListener('onReady', () => {
      this.player.mute();
      this.player.playVideo();
    });
  }

  modalHandler() {
    this.player.addEventListener('onReady', () => {
      super.modalHandler();
    });
  }

  stop() {
    this.player.stopVideo();
  }

  play() {
    this.player.playVideo();
  }
}
